import View from './View';
import * as layout from './layout';
import * as body from './body';
import * as popover from './popover';

export {
    View,
    body,
    layout,
    popover
};



// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/views/index.js